import {MNullable} from '../../Toolkit/Utils';

export class Note {
    public id: string = '';
    public requestId: string = '';
    public noteStatus: number = 0;
    public noteUser: string = '';
    public noteText: string = '';
    public modifiedOn: MNullable<Date> = null;
};

export class NoteReply {
    public note: MNullable<Note> = null;
};

export class NoteMultiReply {
    public notes: Note[] = [];
};